import React, { useMemo, useState } from 'react';
import { Option } from './components/Option';
import { ChevronIcon, Container, Content, ContentAndArrowContainer, IconContainer, List } from './Dropdown.styles';
import { useOutsideClick } from 'hooks/useOutsideClick';
import mixpanel from 'mixpanel-browser';

export type OptionType = { label: string; value: any; [key: string]: any };

interface DropdownProps {
  name: string;
  options: OptionType[];
  onChange?: (option: OptionType) => void;
  selectedOption?: OptionType;
  id: string;
  disabled?: boolean;
}

export const DropdownComponent = ({ name, options, onChange, selectedOption, id, disabled }: DropdownProps) => {
  const [showList, setShowList] = useState(false);

  const handleOutsideClick = () => {
    setShowList(false);
  };

  const ref = useOutsideClick(handleOutsideClick);

  const handleOptionSelect = (option: OptionType) => {
    onChange(option);
    mixpanel.track('DropdownOptionSelected', { label: option.label });
    setShowList(false);
  };

  const handleShowListToggle = () => {
    if (!disabled) {
      if (showList === false) {
        setShowList(true);
        mixpanel.track('DropdownShown', { name });
      } else {
        setShowList(false);
      }
    }
  };

  const optionsToRender = useMemo(() => {
    if (options?.length && selectedOption) {
      return options.filter((option) => option.value !== selectedOption.value);
    }
  }, [options, selectedOption]);

  return (
    <Container disabled={disabled} ref={ref}>
      {selectedOption && (
        <ContentAndArrowContainer isOpen={showList} onClick={handleShowListToggle}>
          <Content forSelectedOption>
            <Option {...selectedOption} key={selectedOption.value} selected isDropdownOpen={showList} />
          </Content>
          <IconContainer>
            <ChevronIcon $rotate={showList} disabled={disabled} />
          </IconContainer>
        </ContentAndArrowContainer>
      )}
      {showList && (
        <List>
          {optionsToRender.map((option: OptionType) => (
            <Content key={option.value}>
              <Option {...option} onClick={() => handleOptionSelect(option)} />
            </Content>
          ))}
        </List>
      )}
    </Container>
  );
};
